import { headScript as raygun } from '../helpers';
import { headScript as fid } from '../../performance/fid';
import { headScript as tti } from '../../performance/tti';

export default function() {
    return `
        ${raygun}
        ${fid}
        ${tti}
    `;
}
